import React from 'react';
import './RelyOnUs.scss';

export const RelyOnUs = () => {
    return (
        <div className='rely'>
            <div className='container'>
                <div className='relay__wrapp'>
                    <div className='relay__wrapp-left'>
                        <h4>На нас можно положиться:</h4>
                        <span>Перед началом работы мы всё тщательно планируем, разбиваем на этапы. Устанавливаем приоритеты.</span>
                        <span>Поэтому мы всегда выполняем работу вовремя, потому что соблюдение основных условий договора — залог успеха.</span>
                    </div>
                    <div className='relay__wrapp-right'>
                    </div>
                </div>
            </div>
        </div>
    )
}